// @flow

// Effect Managers
import { call, fork, race, select, take } from 'redux-saga/effects'

// Action Types
import {
  ADD_SOILJOB,
  EDIT_SOILJOB,
  ADD_TABLE_SOILJOB,
} from 'hfty-soil-jobs-dom/src/constants'

// Controller
import gridCtrl from 'hfty-ctrl-grid'
import assetsCtrl from 'fc-ctrl-assets'

// Selectors
import { firstAvailableGrowerId$ } from 'fc-assets'

// Sagas
import handleTableOperations from './handleTableOperations'
import handleMapOperations from './handleMapOperations'

export function *fetchGrids (): Generator<*, *, *> {
  let attempts = 0
  let growerId = null
  while (attempts < 3 && !growerId) {
    attempts++
    yield take(assetsCtrl.actionTypes.receive())
    growerId = yield select(firstAvailableGrowerId$)
  }

  if (growerId) {
    const queryParams = {
      rootAsset: growerId,
    }
    // const { error, response } = yield call(gridCtrl.read, { queryParams })
    yield call(gridCtrl.read, { queryParams })
  }
}

export default function *main (): Generator<*, *, *> {
  // initialize the controller
  yield call(gridCtrl.start)

  // now we play the waiting (**watching) game
  yield fork(gridCtrl.watch)
  yield fork(fetchGrids)

  while (true) {
    // watching
    const { map, table } = yield race({
      map: take([ADD_SOILJOB, EDIT_SOILJOB]),
      table: take([ADD_TABLE_SOILJOB]),
    })

    if (map) {
      yield fork(handleMapOperations)
    } else if (table) {
      yield fork(handleTableOperations)
    }
  }
}
